<app-summary-card-template [chipNumber]="logBook.totalAmountOfErrors" [loggableEntity]="logBook"
                           [occurredDate]="logBook.createdAt">
</app-summary-card-template>
